import React from 'react';
import { Card } from '../../components/ui/Card';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Truck, FileText, CheckSquare } from 'lucide-react';
interface OrderListProps {
  onPODClick?: () => void;
}
export function OrderList({
  onPODClick
}: OrderListProps) {
  const orders = [{
    id: 'DO-2025-001',
    date: '2025-05-20',
    dest: 'Pasar Induk Cipinang',
    program: 'SPHP Beras',
    qty: 10,
    status: 'In Transit',
    transporter: 'PT Pos Logistik'
  }, {
    id: 'DO-2025-002',
    date: '2025-05-20',
    dest: 'Kelurahan Kebon Jeruk',
    program: 'Bantuan Pangan',
    qty: 25,
    status: 'Delivered',
    transporter: 'DNR'
  }, {
    id: 'DO-2025-003',
    date: '2025-05-19',
    dest: 'RPK Sumber Rejeki',
    program: 'SPHP Beras',
    qty: 2,
    status: 'Planned',
    transporter: 'Swakelola'
  }];
  const columns = [{
    header: 'No. DO',
    accessor: (item: any) => <span className="font-mono text-sm font-semibold text-bulog-blue" data-id="element-424">
          {item.id}
        </span>
  }, {
    header: 'Tanggal',
    accessor: 'date',
    className: 'hidden sm:table-cell'
  }, {
    header: 'Tujuan',
    accessor: (item: any) => <div className="min-w-0" data-id="element-425">
          <div className="font-medium text-gray-900 truncate" data-id="element-426">{item.dest}</div>
          <div className="text-xs text-gray-500 mt-0.5" data-id="element-427">{item.program}</div>
        </div>
  }, {
    header: 'Qty',
    accessor: (item: any) => <span className="font-semibold text-gray-900" data-id="element-428">{item.qty} Ton</span>,
    className: 'hidden md:table-cell'
  }, {
    header: 'Transporter',
    accessor: 'transporter',
    className: 'hidden lg:table-cell'
  }, {
    header: 'Status',
    accessor: (item: any) => {
      const colors: any = {
        'In Transit': 'warning',
        Delivered: 'success',
        Planned: 'neutral'
      };
      return <Badge variant={colors[item.status]} data-id="element-429">{item.status}</Badge>;
    }
  }, {
    header: 'Aksi',
    accessor: (item: any) => <div className="flex gap-2" data-id="element-430">
          <Button size="sm" variant="ghost" icon={<FileText size={14} data-id="element-432" />} data-id="element-431">
            Detail
          </Button>
          {item.status === 'Delivered' && <Button size="sm" variant="outline" onClick={onPODClick} icon={<CheckSquare size={14} data-id="element-434" />} data-id="element-433">
              POD
            </Button>}
        </div>
  }];
  return <div className="space-y-6" data-id="element-435">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-436">
        <div data-id="element-437">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-438">Order Distribusi</h1>
          <p className="text-gray-500 mt-1" data-id="element-439">Pantau pengiriman dan status DO</p>
        </div>
        <Button icon={<Truck size={16} data-id="element-441" />} className="w-full sm:w-auto" data-id="element-440">
          Buat Order Baru
        </Button>
      </div>

      <Card data-id="element-442">
        <Table data={orders} columns={columns} keyExtractor={i => i.id} data-id="element-443" />
      </Card>
    </div>;
}